<div class="container {{ color }}">
    <div
        class="header body-medium"
        [class.one-line]="labelOneLine"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(label || '')"
    ></div>
    <div class="content">
        @if (!hideValue) {
            <web-fading-span
                [valueClass]="valueClass"
                [suffixClass]="suffixClass"
                [autorizeZero]="autorizeZero"
                [value]="value || (value === 0 && suffix === '%') || (value === 0 && autorizeZero) ? value : '-'"
                [suffix]="value || (value === 0 && suffix === '%') || (value === 0 && autorizeZero) ? suffix : ''"
            ></web-fading-span>
        }
        <ng-content></ng-content>
    </div>
</div>
